// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__jJtrG","label":"styles_label__JukNX","caption":"styles_caption__znAZS","description":"styles_description__Xz1s5","content":"styles_content__78_Zi"};